"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DbGuidePlaceUsefulLinkView = void 0;
var React = require("react");
var DbguideContact_1 = require("@/pages/dbguide/components/DbguideContact");
exports.DbGuidePlaceUsefulLinkView = function (props) {
    var onBackClick = function () { return props.onBackClick(); };
    var renderUsefulLinkSection = function (section, i) { return (React.createElement("div", { key: i, className: "c-guides__section" },
        React.createElement("div", { className: "c-guides__head" }, section.title),
        React.createElement("div", { className: "c-guides__text" }, section.description),
        React.createElement("div", { className: "c-guides__caption" }, section.contacts ? section.contacts.map(DbguideContact_1.renderContactRow) : ''))); };
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: "c-guides__nav" },
            React.createElement("div", { onClick: onBackClick, id: "back", className: "c-guides__back" },
                React.createElement("span", { className: "fas fa-chevron-left" })),
            React.createElement("div", { className: "c-guides__title" }, props.name),
            React.createElement("div", { className: "c-guides__done" })),
        React.createElement("div", { className: "c-guides__body" }, props.sections.map(renderUsefulLinkSection))));
};
